module.exports = __webpack_public_path__ + "img/haunted_mine_small.502efe5c.png";